// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_NGW","cls2":"TranslationModal-cls2_sh9 TranslationModal-cls1_NGW"};